// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"bc51e662","161":"3009175f","209":"e1f55257","248":"a327377d","478":"802e8c93","562":"f3989ece","625":"c5227c16","787":"1770fad8","922":"a9748d02","999":"874c8d9c"}[chunkId] + ".chunk.js";
};